import { render, staticRenderFns } from "./slide-modal.vue?vue&type=template&id=ba071302&scoped=true"
import script from "./slide-modal.vue?vue&type=script&lang=js"
export * from "./slide-modal.vue?vue&type=script&lang=js"
import style0 from "./slide-modal.vue?vue&type=style&index=0&id=ba071302&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ba071302",
  null
  
)

export default component.exports